export const homeurl='../'
export const quiz_filename='MA10.json'
export const quiz_url='https://qccmathcs.github.io/MA10_FINAL_REVIEW/'
//export const quiz_url='https://ma10quiz-kwangkim.c9users.io/'
//https://github.com/ReactTraining/react-router/issues/3643
export const quiz_path='/quiz/'
export const quiz_main='/'
export const video_path='https://youtu.be/'
export const default_qnum=0
export const quizID='MA10CEAFE1'
export const websiteurl='http://www.qcc.cuny.edu/mathCS/study/MA10/FINAL'
//export const websiteurl='https://ma10quiz-kwangkim.c9users.io'
export const ga_ID='UA-89071926-2' // http://www.qcc.cuny.edu/mathCS/study/MA010/Final/
//export const ga_ID='UA-89071926-1' //testing ma10 https://ma10quiz-kwangkim.c9users.io/#/quiz/14
export const backlink='http://www.qcc.cuny.edu/MathCS'
export const SampleC='https://www2.cuny.edu/wp-content/uploads/sites/4/page-assets/academics/testing/Sample-CEAFE-C-1.pdf'
export const SampleD='https://www2.cuny.edu/wp-content/uploads/sites/4/page-assets/academics/testing/Sample-CEAFE-D-1.pdf'
export const SampleE='http://www2.cuny.edu/wp-content/uploads/sites/4/page-assets/academics/testing/Sample-CEAFE-E-2.pdf'
export const title='QCC MA10 Final'


// WEBPACK FOOTER //
// ./src/constants/index.js